import axios from 'axios'
import { useAuthStore } from '@/stores/auth'

// In production, the Go binary serves the frontend - no base URL needed.
axios.defaults.baseURL = process.env.VUE_APP_API_URL || ''

// No request interceptor needed - JWT cookie is sent automatically by the browser.

// Response interceptor - handle expired sessions
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      const authStore = useAuthStore()
      if (authStore.initialized) {
        // Session expired mid-use - redirect to login
        authStore.clearSession()
        window.location.href = '/#/login'
      }
    }
    return Promise.reject(error)
  }
)
